import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

export default class ProgressSteps extends Component {
  static propTypes = {
    gotoStage: PropTypes.func.isRequired,
    stage1Active: PropTypes.bool.isRequired,
    stage2Active: PropTypes.bool.isRequired,
    stage3Active: PropTypes.bool.isRequired,
    stage1Complete: PropTypes.bool.isRequired,
    stage2Complete: PropTypes.bool.isRequired,
    stage3Complete: PropTypes.bool.isRequired,
  }

  render() {
    const {
      stage1Active,
      stage2Active,
      stage3Active,
      stage1Complete,
      stage2Complete,
      stage3Complete,
      gotoStage,
    } = this.props

    let stage1ClassName = classnames([
      'progress-steps__item',
      stage1Active && 'progress-steps__item--active',
      stage1Complete && 'progress-steps__item--complete',
    ])

    let stage2ClassName = classnames([
      'progress-steps__item',
      stage2Active && 'progress-steps__item--active',
      stage2Complete && 'progress-steps__item--complete',
    ])

    let stage3ClassName = classnames([
      'progress-steps__item',
      stage3Active && 'progress-steps__item--active',
      stage3Complete && 'progress-steps__item--complete',
    ])

    return (
      <ul className='list list--unstyled progress-steps hidden-mobile hidden-tablet'>
        <li className={stage1ClassName}>
          <button
            className='btn btn--link step-btn'
            type='button'
            aria-label='Go to section'
            onClick={() => gotoStage(1)}
          >
            <span className='step-btn__add-on'></span> Gross Development Value
          </button>
        </li>
        <li className={stage2ClassName}>
          <button
            className='btn btn--link step-btn'
            type='button'
            aria-label='Go to section'
            onClick={() => gotoStage(2)}
          >
            <span className='step-btn__add-on'></span> Building and Marketing Costs
          </button>
        </li>
        <li className={stage3ClassName}>
          <button
            className='btn btn--link step-btn'
            type='button'
            aria-label='Go to section'
            onClick={() => gotoStage(3)}
          >
            <span className='step-btn__add-on'></span> Profit and Land Value
          </button>
        </li>
      </ul>
    )
  }
}
